// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__FwOk9","noInteraction":"EventWrapper_noInteraction__2DflL"};